// extracted by mini-css-extract-plugin
export default {"comp":"index_comp__G0QOY","logo":"index_logo__WaUCn","title":"index_title__Z2jJ2"};